function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChainLink = function SvgChainLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    fillRule: "evenodd",
    d: "M12.673 3.764a5.34 5.34 0 0 1 3.769-1.514 5.34 5.34 0 0 1 3.741 1.58 5.405 5.405 0 0 1 .065 7.548l-.008.01-2.763 2.782a5.325 5.325 0 0 1-6.359.92 5.4 5.4 0 0 1-1.72-1.502.75.75 0 0 1 1.204-.895c.332.447.754.815 1.24 1.082a3.83 3.83 0 0 0 4.57-.662l2.758-2.778a3.9 3.9 0 0 0 1.08-2.732 3.9 3.9 0 0 0-1.131-2.716 3.84 3.84 0 0 0-2.69-1.137 3.84 3.84 0 0 0-2.706 1.086l-1.58 1.582a.75.75 0 0 1-1.062-1.06z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    fillRule: "evenodd",
    d: "M8.44 8.59a5.33 5.33 0 0 1 4.442.32c.674.372 1.26.884 1.72 1.502a.75.75 0 0 1-1.204.895 3.9 3.9 0 0 0-1.24-1.082 3.83 3.83 0 0 0-4.57.662L4.83 13.665a3.9 3.9 0 0 0-1.08 2.732 3.9 3.9 0 0 0 1.131 2.716 3.84 3.84 0 0 0 2.69 1.137 3.84 3.84 0 0 0 2.706-1.085l1.57-1.581a.75.75 0 0 1 1.064 1.057l-1.584 1.595a5.34 5.34 0 0 1-3.769 1.514 5.34 5.34 0 0 1-3.741-1.58 5.4 5.4 0 0 1-1.567-3.76 5.4 5.4 0 0 1 1.501-3.788l.01-.01L6.522 9.83A5.35 5.35 0 0 1 8.44 8.59",
    clipRule: "evenodd"
  }));
};
export default SvgChainLink;